import React from 'react';
import * as D from '../utils/Date';

export const useDate = () => {
	const [date, setDate] = React.useState(new Date());

	const getFormatDate = (fm = 'yyyy.MM.dd') => D.getFormatDate(date, fm);

	const setMonths = (isNext, amount = 1) => {
		if (isNext) setDate(D.addMonths(date, amount));
		else setDate(D.subMonths(date, amount));
	};

	const setDays = (isNext, amount = 1) => {
		if (isNext) setDate(D.addDays(date, amount));
		else setDate(D.subDays(date, amount));
	};

	const isFutureDate = (type = 'day', amount = 1) => {
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		const currentDate = new Date(date);
		currentDate.setHours(0, 0, 0, 0);

		let nextDate;
		if (type === 'day') {
			nextDate = D.addDays(currentDate, amount);
		} else if (type === 'month') {
			nextDate = D.addMonths(currentDate, amount);
		}
		return nextDate > today;
	};

	return {
		date,
		getFormatDate,
		setMonths,
		setDays,
		isFutureDate,
	};
};
